import type { Cluster } from "~/types";

// Untagged SaaS clusters form an implicit group; untagged BYOC stays
// unmanaged. The value is rejected as an explicit tag.
const CATCHALL_GROUP = "catch-all";

/** A tag selector is `key:value`; null when it isn't. */
export function parseFleetTag(
  tag: string,
): { key: string; value: string } | null {
  const split = tag.indexOf(":");
  if (split <= 0 || split === tag.length - 1) return null;
  return { key: tag.slice(0, split), value: tag.slice(split + 1) };
}

export function compareRolloutGroups(
  a: string,
  b: string,
  order?: string[],
): number {
  if (a === b) return 0;
  if (order) {
    const aIndex = order.indexOf(a);
    const bIndex = order.indexOf(b);
    if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
    if (aIndex !== -1) return -1;
    if (bIndex !== -1) return 1;
  }
  if (a === CATCHALL_GROUP) return 1;
  if (b === CATCHALL_GROUP) return -1;
  return a.localeCompare(b, undefined, { numeric: true });
}

export function rolloutGroup(cluster: Cluster): string | null {
  if (cluster.tags?.rollout) return cluster.tags.rollout;
  if (cluster.tags?.kind !== "byoc") return CATCHALL_GROUP;
  return null;
}

/** How `group by rollout` buckets and orders the cluster list. */
export function rolloutGrouping(order?: string[]) {
  return {
    valueOf: rolloutGroup,
    compare: (a: string, b: string) => compareRolloutGroups(a, b, order),
  };
}
